import axios from "axios";
import { AUTH_PROFILE } from "constants/AuthConstant";

export async function discordWebhook(errorCode, errorResponse) {
  const DISCORD_WEBHOOK =
    "https://discord.com/api/webhooks/1473564352354451599/6icNx6FJoR_ho68rKbr9C8wks0Tm0DQb0QTcczrZ3CnFXY6iC4OyY9Lp-US5gfvFdMnq";

  // Get user data from localStorage using AUTH_PROFILE
  const user = JSON.parse(localStorage.getItem(AUTH_PROFILE));

  // Get current date
  const date = new Date().toLocaleString("en-GB", {
    timeZone: "Asia/Jakarta", // GMT+7 timezone
    hour12: false, // 24-hour format
  });

  // Get current page URL
  const currentLink = window.location.href;

  // Format the error message
  const errorMessageString = errorResponse?.data?.errors
    ? `\`\`\`json\n${JSON.stringify(errorResponse.data.errors, null, 2)}\n\`\`\``
    : `\`\`\`text\n${errorResponse.message || "No details available"}\n\`\`\``;

  // Create the message string
  const messageString = `Username : ${user?.name}
Date : ${date}
Error : ${errorCode}
Link : ${currentLink}
Detail : ${errorMessageString}`;

  // If message is under 2000 characters, send it directly
  if (messageString.length <= 2000) {
    await axios.post(
      DISCORD_WEBHOOK,
      JSON.stringify({ content: messageString }),
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  } else {
    // If message is too long, split it into chunks and send each part
    const chunkSize = 2000;
    for (let i = 0; i < messageString.length; i += chunkSize) {
      await axios.post(
        DISCORD_WEBHOOK,
        JSON.stringify({ content: messageString.substring(i, i + chunkSize) }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
    }
  }
}
